<template>
  <div class="auth-sidefooter">
    <hr class="mb-2 mt-2" />
    <div class="row">
      <div class="col my-1">
        <p class="m-0">{{ $t('common.footer.copyright', { year: currentYear }) }}</p>
      </div>
      <div class="col-auto my-1">
        <ul class="list-inline footer-link mb-0">
          <li class="list-inline-item"><a href="https://vesproc.com/" target="_blank" rel="noopener noreferrer">{{ $t('common.navigation.home') }}</a></li>
          <li class="list-inline-item"><a href="mailto:support@vesproc.com">{{ $t('common.footer.support') }}</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const currentYear = computed(() => new Date().getFullYear());
</script>

<style scoped>
.auth-sidefooter {
  margin-top: 20px;
}

.footer-link a {
  padding: 0;
  text-decoration: none;
  color: #212529;
  transition: color 0.3s ease;
}

.footer-link a:hover {
  color: #00A0DF;
}

.footer-link li {
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.footer-link li:first-child {
  padding-left: 0;
}

.footer-link li:last-child {
  border-right: none;
  padding-right: 0;
}
</style>

